const router = [
  {
    path: "/news",
    meta: {
      title: "",
      keepAlive: true
    },
    component: resolve => require(["../views/news/news"], resolve)
  },
  {
    path: "/newDetail",
    meta: {
      title: "",
      keepAlive: false
    },
    component: resolve => require(["../views/newDetail/index"], resolve)
  }
];

export default router;



// WEBPACK FOOTER //
// ./src/router/news.js